import styles from './Button.module.css';

export default function Button({
  variant = 'primary',
  block = false,
  large = false,
  // 0.48.54 - An icon-only button: the Henaket 40 x 40 square.
  icon = false,
  loading = false,
  disabled = false,
  type = 'button',
  children,
  className = '',
  ...rest
}) {
  const classNames = [
    styles.button,
    styles[variant],
    block ? styles.block : '',
    large ? styles.large : '',
    icon ? styles.icon : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={classNames} disabled={disabled || loading} {...rest}>
      {loading && <span className={styles.spinner} aria-hidden="true" />}
      {children}
    </button>
  );
}
